import { Container, Paper } from "@mantine/core";
import * as React from "react";
import { Helmet } from "react-helmet-async";
import { AdminPageTitle } from "../adminPageTitle";

const AdminPage = React.forwardRef(
  ({ children, title = "Faces2Hire Admin", meta, ...other }, ref) => (
    <>
      <Helmet>
        <title>{title}</title>
        {meta}
      </Helmet>

      <Container
        ref={ref}
        {...other}
        p="xl"
        size="xl"
        style={{ backgroundColor: "rgb(248, 248, 248)" }}
      >
        <AdminPageTitle title={title} />
        <Paper
          p="xl"
          shadow="lg"
          radius="md"
          // withBorder
          style={{
            border: "1px solid rgb(0,0,0,0.1)",
          }}
        >
          {children}
        </Paper>
      </Container>
    </>
  )
);

export default AdminPage;
